import * as Sentry from '@sentry/browser';

function captureException(error, extras = null) {
  Sentry.withScope((scope) => {
    if (extras) {
      scope.setExtras(extras);
    }
    Sentry.captureException(error);
  });
}

export { Sentry, captureException };
